//* 全局属性
import type { NavigateToRoute } from "@/utils/router/src/types";
//* 工具函数
import { Formats } from "@/assets/js";

export const useComposable = () => {
    //* 插件
    const route = useRoute();

    //* 响应式变量
    const refs = {
        mode: ref<string>(""),
        keyword: ref<string>(Formats.query(route.query.keyword)),
    };

    //* 配置项
    const options = {
        mode: <{ [name: string]: string }>{
            tool: "Tool",
            gene: "Gene",
            model: "Model",
            disease: "Disease",
            mutation: "Mutation",
        },
    };

    //* 函数列表
    const methods = {
        init: () => {
            //* 根据路由初始化搜索框类型
            const routeName = route.meta?.route;
            if (routeName == "SearchGene") refs.mode.value = "gene";
            else if (routeName == "SearchTool") refs.mode.value = "tool";
            else if (routeName == "SearchModel") refs.mode.value = "model";
            else if (routeName == "SearchDisease") refs.mode.value = "disease";
            else if (routeName == "SearchMutation") refs.mode.value = "mutation";
            else {
                refs.mode.value = "";
            }
        },

        next: (context: string, mode: string, id?: string) => {
            //* 数据初始化
            const keyword = context?.trim();
            //* 检测是否存在关键词
            if (!keyword) return;
            //* 有返回id和类型 直接跳转到详情页
            if (!mode) routerPush({ name: "Search", query: { keyword: keyword, date: new Date().getTime() } });
            else {
                const config = { mode: options.mode[mode], route: {} as string | NavigateToRoute };
                if (!id) config.route = { name: "Search" + config.mode, query: { keyword: keyword, date: new Date().getTime() } };
                else {
                    if (config.mode == "Tool") config.route = id;
                    else {
                        config.route = { name: config.mode, params: { id: id } };
                    }
                }

                open(routerResolve(config.route).href as string);
            }
        },
    };

    //* 计算属性
    const computeds = {
        href: computed(() => {
            const keyword = Formats.query(route.query.keyword)?.trim();
            return {
                name: "Search",
                ...(keyword && {
                    query: { keyword: keyword },
                }),
            };
        }),
    };

    return { refs, methods, computeds };
};
